var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "_flexcol _gap-1" },
    [
      _c(
        "h4",
        { staticClass: "gfu-bt gfu-bt--caption _ttu _fw-n _ma-0" },
        [
          _vm._v("\n        " + _vm._s(_vm.title) + "\n        "),
          !!_vm.tooltip
            ? _c("tooltip", {
                attrs: { text: _vm.tooltip, "icon-name": "circle-info" },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("h4", { staticClass: "gfu-hd gfu-hd--h1" }, [
        _vm._v(_vm._s(_vm.value)),
      ]),
      _vm._v(" "),
      _vm.actionRoute
        ? _c(
            "admin-router-link",
            { staticClass: "_tc--accent", attrs: { to: _vm.actionRoute } },
            [_vm._v("\n        " + _vm._s(_vm.actionLabel) + "\n    ")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }